import { Box, Typography, useMediaQuery } from "@mui/material"
import golf from './picture_yellow_golf.webp';

import { Txt } from "../../../Routes/Localized";
import { fontText, fontTitle, useMobile } from "../../../base";
import { theme } from "../../../Resources/Design/theme";

export default function FeatureSection({
  reverse = false,
  imgReverse = false,
  image = golf,
  svgImage: SvgImage,
  imgChildren,
  title,
  text,
  sx = {},
  sxInside = {},
  sxTitle = {},
  sxText = {},
  sxTextsContainer = {},
  textChildren = null,
  sxFlex = {},
  sxImage = {},
  header = false,
  rightChildren = null,
  sxRight = {},
  sxRightContainer = {},
}) {
  const small = useMediaQuery("(max-width:1100px)");
  const mobile = useMobile();

  const title_def = title || <Txt id={"19010"} />;
  const text_def = text || <Txt id={"19011"} />;

  const smallDisplay = (smallVal, largeVal, headerSmall, headerLarge) => {
    const headerSmallFinal = headerSmall ?? smallVal;
    const headerLargeFinal = headerLarge ?? largeVal;
    if (header) {
      return { xs: headerSmallFinal, sm: headerSmallFinal, md: small ? headerSmallFinal : headerLargeFinal, lg: headerLargeFinal };
    }
    return { xs: smallVal, sm: smallVal, md: small ? smallVal : largeVal, lg: largeVal };
  }

  return (
    <Box sx={{ ...sx }}>
      <Box
        sx={{
          py: smallDisplay('80px', `160px`, '30px'),
          maxWidth: 1400,
          mx: "auto",
          ...sxInside,
          ...(header && small && {
            py: smallDisplay('60px', '0px'),
            px: { xs: '16px', sm: '60px' },
          }),
          ...(mobile && {
            px: '16px',
          }),
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: small ? "column" : `row${reverse ? '-reverse' : ''}`,
            alignItems: small ? "left" : "center",
            alignContent: small ? "left" : "center",
            justifyContent: small ? "auto" : "center",
            gap: smallDisplay('60px', '32px'),
            ...sxFlex,
          }}
        >
          {/* LEFT TEXT */}
          <Box sx={{ flex: 1, maxWidth: smallDisplay('100%', '560px'), textAlign: 'left', ...sxTextsContainer }}>
            <Typography
              sx={{
                "fontFamily": "Inter", "fontWeight": "700",
                "fontStyle": "Bold", textAlign: 'left', ...fontTitle, ...sxTitle
              }}
            >
              {title_def}
            </Typography>

            <Typography
              sx={{
                fontFamily: 'inter', ...fontText, fontWeight: 400, [theme.breakpoints.down('md')]: {
                  fontWeight: 400
                }, mt: '16px', ...sxText
              }}
            >
              {text_def}
            </Typography>

            {Boolean(textChildren) && textChildren}
          </Box>

          {/* RIGHT VISUAL */}
          <Box
            sx={{
              flex: 1,
              position: "relative",
              display: "flex",
              justifyContent: smallDisplay('center', reverse ? 'flex-start' : 'flex-end'),
              ...sxRight,
            }}
          >
            <Box
              sx={{
                borderRadius: 6,
                maxWidth: 640,
                ...(reverse ? { pr: { xs: '0px', sm: '16px' } } : { pl: { xs: '0px', sm: '16px' }, }),
                ...(imgReverse && { transform: 'rotateY(180deg)' }),
                ...sxRightContainer,
              }}
            >
              {Boolean(SvgImage) ? <>
                <SvgImage style={{ width: "100%", height: 'auto', ...sxImage }} />
              </> : <>
                {Boolean(image) && <Box sx={{ position: 'relative' }}>
                  <Box
                    component="img"
                    src={image}
                    alt="Car"
                    sx={{
                      display: 'block',
                      width: "100%",
                      maxHeight: '400px',
                      ...sxImage
                    }}
                  />
                  {imgChildren && <>{imgChildren}</>}
                </Box>}
              </>}
              {Boolean(rightChildren) && rightChildren}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
